import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  Chain19a4phelb7wvt as Chain,
  Assign2jm8flaivtcon as Assign,
} from './Modification.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ModificationBuilderClass;
function ModificationBuilder() {
  if (ModificationBuilderClass === VOID) {
    class $ {
      constructor() {
        this.modifications_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      build_1k0s4u_k$() {
        if (this.modifications_1.get_size_woubt6_k$() === 1)
          return this.modifications_1.get_c1px32_k$(0);
        else
          return Chain().new_com_lightningkite_services_database_Modification_Chain_qdmx0f_k$(this.modifications_1);
      }
      assign_vtsfu6_k$(_this__u8e3s4, value) {
        this.modifications_1.add_utx5q5_k$(_this__u8e3s4.mapModification_jpidl5_k$(Assign().new_com_lightningkite_services_database_Modification_Assign_1ypiqt_k$(value)));
      }
    }
    initMetadataForClass($, 'ModificationBuilder', ModificationBuilder);
    ModificationBuilderClass = $;
  }
  return ModificationBuilderClass;
}
//region block: exports
export {
  ModificationBuilder as ModificationBuilder10ot0rvxki4iq,
};
//endregion

//# sourceMappingURL=ModificationBuilder.mjs.map
